import React from "react";
import { FaFacebook, FaYoutube, FaLinkedin, FaGithub } from "react-icons/fa";
import FooterListTitle from "./FooterListTitle";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Adding translations for the footer
  const footerTranslations = {
    Kayan_Shop_desc: t("footer.Kayan_Shop_desc"),
    Kayan_Shop: t("footer.Kayan_Shop"),
    aboutUs: t("footer.aboutUs"),
    myAccount: t("footer.myAccount"),
    Wishlist: t("footer.wishlist"),
    Logout: t("footer.Logout"),
    orderTracking: t("footer.orderTracking"),
    secureDelivery: t("footer.secureDelivery"),
    needHelp: t("footer.needHelp"),
    allCategories: t("footer.allCategories"),
    searchPlaceholder: t("footer.searchPlaceholder"),
    noProducts: t("footer.noProducts"),
    yourCart: t("footer.yourCart"),
    Home: t("footer.Home"),
    Shop: t("footer.Shop"),
    Addresses: t("footer.Addresses"),
    Orders: t("footer.Orders"),
    Profile: t("footer.Profile"),
    New_Arrivals: t("footer.New_Arrivals"),
    privacyPolicy: t("footer.privacyPolicy"),
    All_Products: t("footer.All_Products")
  };

  return (
    <div className="w-full bg-gradient-to-b from-gray-50 to-gray-100 py-16">
      <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 px-4 gap-10">
        <div className="col-span-2">
          <h3 className="text-4xl font-bold mb-6 text-[#004aad]">
            {footerTranslations.Kayan_Shop}
          </h3>

          <div className="flex flex-col gap-6">
            <p className="text-base w-full xl:w-[80%] text-gray-600 leading-relaxed">
              {footerTranslations.Kayan_Shop_desc}
            </p>
            <span className="flex items-center gap-1.5">
              {t("header.needHelp")}
              <a
                href="tel:0683370706"
                className="hover:text-white/90 transition-colors duration-200 font-medium text-[#FF9933]"
              >
                0683370706
              </a>
            </span>
            <ul className="flex items-center gap-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-[#004aad] text-white hover:bg-[#f7931e] hover:text-white duration-300 cursor-pointer flex justify-center items-center rounded-full"
              >
                <FaFacebook className="text-xl" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-[#004aad] text-white hover:bg-[#f7931e] hover:text-white duration-300 cursor-pointer flex justify-center items-center rounded-full"
              >
                <FaYoutube className="text-xl" />
              </a>
              <a
                href="https://www.github.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-[#004aad] text-white hover:bg-[#f7931e] hover:text-white duration-300 cursor-pointer flex justify-center items-center rounded-full"
              >
                <FaGithub className="text-xl" />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-[#004aad] text-white hover:bg-[#f7931e] hover:text-white duration-300 cursor-pointer flex justify-center items-center rounded-full"
              >
                <FaLinkedin className="text-xl" />
              </a>
            </ul>
          </div>
        </div>

        <div>
          <FooterListTitle title={footerTranslations.aboutUs} />
          <ul className="flex flex-col gap-2">
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Home}
            </li>
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Shop}
            </li>

            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.aboutUs}
            </li>
            <li
              onClick={() => {
                navigate(`/privacy`);

              }}
              className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.privacyPolicy}
            </li>
          </ul>
        </div>

        <div>
          <FooterListTitle title={footerTranslations.myAccount} />
          <ul className="flex flex-col gap-2">
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Profile}
            </li>
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Orders}
            </li>
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Wishlist}
            </li>
            <li className=" text-base text-gray-600 hover:text-[#f7931e] hover:underline decoration-[1px] decoration-[#f7931e] underline-offset-2 cursor-pointer duration-300">
              {footerTranslations.Logout}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
